import React from 'react';

import { Form } from '@unform/web';
import { useFormik, FormikProvider } from 'formik';

import Select from '~/components/Formik/Select';
import SelectButton from '~/components/Formik/SelectButton';
import { IProcess } from '~/store/modules/processes/types';
import { AssignedTo, IFilterTaskParams } from '~/store/modules/tasks/types';
import { IActivatedUsers, IUser } from '~/store/modules/users/types';

import { FilterTitle, SubmitFilterButton } from '../styles';

export interface FormTableData {
  processDefinitionNames?: string[];
  assigneeIn?: IUser[];
  assignedTo?: { label: AssignedTo; value: AssignedTo }[];
}

interface FilterTasksFormProps {
  filterParams: IFilterTaskParams;
  activeUsers: IActivatedUsers[];
  onSubmit: (data: FormTableData) => void;
  processDefinitions?: IProcess[];
}

const FilterTasksForm: React.FC<FilterTasksFormProps> = ({
  filterParams,
  activeUsers,
  onSubmit,
  processDefinitions,
}) => {
  const initialValues: FormTableData = {
    processDefinitionNames: filterParams.processDefinitionNames,
    assignedTo: filterParams.assignedTo
      ? [
          {
            label: filterParams.assignedTo,
            value: filterParams.assignedTo,
          },
        ]
      : undefined,
    assigneeIn: filterParams.assigneeIn,
  };

  const formik = useFormik({ initialValues, onSubmit });

  return (
    <FormikProvider value={formik}>
      <Form
        onSubmit={formik.handleSubmit}
        style={{
          margin: '1.143rem',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          gap: '1.143rem',
        }}
      >
        <div>
          <SelectButton
            name="assignedTo"
            type="checkbox-radio"
            options={[
              { value: AssignedTo.ME, label: 'Para mim' },
              { value: AssignedTo.OTHERS, label: 'Para outros' },
            ]}
          />
          <FilterTitle>Processo</FilterTitle>
          <Select
            name="processDefinitionNames"
            placeholder=""
            isClearable
            closeMenuOnSelect={false}
            options={processDefinitions?.map((process) => {
              return {
                value: process.name,
                label: process.name,
              };
            })}
            isMulti
          />

          {(!formik.values.assignedTo ||
            formik.values.assignedTo.length < 1 ||
            formik.values.assignedTo[0].value !== AssignedTo.ME) && (
            <>
              <FilterTitle>Responsável</FilterTitle>
              <Select
                name="assigneeIn"
                placeholder=""
                isClearable
                closeMenuOnSelect={false}
                options={
                  activeUsers.length >= 1
                    ? activeUsers.map((activeUser) => {
                        return {
                          value: activeUser,
                          label: `${activeUser.firstName} ${activeUser.lastName}`,
                        };
                      })
                    : []
                }
                isMulti
              />
            </>
          )}
        </div>
        <SubmitFilterButton type="submit">Filtrar</SubmitFilterButton>
      </Form>
    </FormikProvider>
  );
};

export default FilterTasksForm;
